import cn from "classnames";
import { useTranslation } from "localization/localization";
import { HeaderStepsProps } from "./Header.types";
import s from "./Header.module.scss";

const steps = [
  { label: "1. Packing list", variantClass: "start" },
  { label: "2. Loading", variantClass: "half" },
  { label: "3. Stuffing Result", variantClass: "end" },
];

export const HeaderSteps = ({ currentStep }: HeaderStepsProps) => {
  const { t } = useTranslation();

  return (
    <div className={s.stepBox}>
      <div className={s.stepWrapper}>
        {steps.map((step, idx) => {
          const stepNum = idx + 1;
          return (
            <span
              key={idx}
              className={cn(s.step, {
                [s.active]: currentStep >= stepNum,
              })}
            >
              {t(step.label)}
            </span>
          );
        })}
      </div>

      <div className={s.progress}>
        <div
          className={cn(s.line, {
            [s[steps[currentStep - 1].variantClass]]: currentStep <= steps.length,
          })}
        ></div>
      </div>
    </div>
  );
};
